import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { motion } from "framer-motion";

const achievements = [
  {
    name: "Step Master",
    description: "Walked 10,000 steps daily for a month",
    date: "2023-05-15",
  },
  {
    name: "Mindfulness Guru",
    description: "Meditated for 30 days straight",
    date: "2023-06-01",
  },
  {
    name: "Nutrition Wizard",
    description: "Maintained a balanced diet for 3 months",
    date: "2023-07-10",
  },
  {
    name: "Sleep Champion",
    description: "Achieved 8 hours of sleep for 2 weeks",
    date: "2023-08-05",
  },
  {
    name: "Hydration Hero",
    description: "Drank 8 glasses of water daily for a month",
    date: "2023-09-20",
  },
];

const LongevityAchievements = () => {
  return (
    <Card className={""}>
      <CardHeader className={""}>
        <CardTitle className={""}>Longevity Achievements</CardTitle>
      </CardHeader>
      <CardContent>
        {achievements?.map((achievement, index) => (
          <motion.div
            key={achievement.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="mb-4 last:mb-0"
          >
            <div className="flex justify-between items-center">
              <Badge variant="secondary" className={""}>
                {achievement.name}
              </Badge>
              <span className="text-sm text-muted-foreground">
                {achievement.date}
              </span>
            </div>
            <p className="text-sm mt-1">{achievement.description}</p>
          </motion.div>
        ))}
      </CardContent>
    </Card>
  );
};

export default LongevityAchievements;
